/* tslint:disable */
/* eslint-disable */
/**
 * C24 Community API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ApiBackofficeInformation200Response
 */
export interface ApiBackofficeInformation200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiBackofficeInformation200Response
     */
    'postDetailsUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ApiBackofficeInformation200Response
     */
    'commentDetailsUrl': string;
}
/**
 * 
 * @export
 * @interface ApiBuildInformation200Response
 */
export interface ApiBuildInformation200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiBuildInformation200Response
     */
    'deployedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApiBuildInformation200Response
     */
    'imageTag': string;
    /**
     * 
     * @type {string}
     * @memberof ApiBuildInformation200Response
     */
    'lastCommitAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApiBuildInformation200Response
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface ApiCommunityNotificationsAuthRequest
 */
export interface ApiCommunityNotificationsAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiCommunityNotificationsAuthRequest
     */
    'socket_id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiCommunityNotificationsAuthRequest
     */
    'channel_name': string;
}
/**
 * 
 * @export
 * @interface ApiEnvironmentsList200ResponseInner
 */
export interface ApiEnvironmentsList200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof ApiEnvironmentsList200ResponseInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiEnvironmentsList200ResponseInner
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ApiGroupPostingAlternatives200Response
 */
export interface ApiGroupPostingAlternatives200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiGroupPostingAlternatives200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Group>}
     * @memberof ApiGroupPostingAlternatives200Response
     */
    'groups'?: Array<Group>;
}
/**
 * 
 * @export
 * @interface ApiGroupPostingAlternatives404Response
 */
export interface ApiGroupPostingAlternatives404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiGroupPostingAlternatives404Response
     */
    'errors'?: string;
}
/**
 * 
 * @export
 * @interface ApiGroupSuggest200Response
 */
export interface ApiGroupSuggest200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiGroupSuggest200Response
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiGroupSuggest200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<ApiGroupSuggest200ResponseGroupsInner>}
     * @memberof ApiGroupSuggest200Response
     */
    'groups'?: Array<ApiGroupSuggest200ResponseGroupsInner>;
    /**
     * 
     * @type {Array<PromotedGroup>}
     * @memberof ApiGroupSuggest200Response
     */
    'promotedGroups'?: Array<PromotedGroup>;
}
/**
 * 
 * @export
 * @interface ApiGroupSuggest200ResponseGroupsInner
 */
export interface ApiGroupSuggest200ResponseGroupsInner {
    /**
     * 
     * @type {number}
     * @memberof ApiGroupSuggest200ResponseGroupsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiGroupSuggest200ResponseGroupsInner
     */
    'name'?: string;
    /**
     * 
     * @type {ApiGroupSuggest200ResponseGroupsInnerImage}
     * @memberof ApiGroupSuggest200ResponseGroupsInner
     */
    'image'?: ApiGroupSuggest200ResponseGroupsInnerImage;
}
/**
 * 
 * @export
 * @interface ApiGroupSuggest200ResponseGroupsInnerImage
 */
export interface ApiGroupSuggest200ResponseGroupsInnerImage {
    /**
     * 
     * @type {number}
     * @memberof ApiGroupSuggest200ResponseGroupsInnerImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiGroupSuggest200ResponseGroupsInnerImage
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ApiHotelSuggest200Response
 */
export interface ApiHotelSuggest200Response {
    /**
     * 
     * @type {number}
     * @memberof ApiHotelSuggest200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GroupSuggestion>}
     * @memberof ApiHotelSuggest200Response
     */
    'groups'?: Array<GroupSuggestion>;
    /**
     * 
     * @type {Array<PromotedGroup>}
     * @memberof ApiHotelSuggest200Response
     */
    'promotedGroups'?: Array<PromotedGroup>;
}
/**
 * 
 * @export
 * @interface ApiReferrerurlValidate200Response
 */
export interface ApiReferrerurlValidate200Response {
    /**
     * either the passed url if valid or https://check24.de as a fallback
     * @type {string}
     * @memberof ApiReferrerurlValidate200Response
     */
    'validReferrerUrl'?: string;
}
/**
 * 
 * @export
 * @interface ApiReferrerurlValidateRequest
 */
export interface ApiReferrerurlValidateRequest {
    /**
     * Url to validate
     * @type {string}
     * @memberof ApiReferrerurlValidateRequest
     */
    'referrerUrl': string;
}
/**
 * 
 * @export
 * @interface ApiUserAchievementsHighestEarnedOrNext200Response
 */
export interface ApiUserAchievementsHighestEarnedOrNext200Response {
    /**
     * 
     * @type {string}
     * @memberof ApiUserAchievementsHighestEarnedOrNext200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<UserAchievement>}
     * @memberof ApiUserAchievementsHighestEarnedOrNext200Response
     */
    'achievements'?: Array<UserAchievement>;
}
/**
 * 
 * @export
 * @interface ApiUserFollowRequest
 */
export interface ApiUserFollowRequest {
    /**
     * Source type of the follow action
     * @type {string}
     * @memberof ApiUserFollowRequest
     */
    'source'?: ApiUserFollowRequestSourceEnum;
    /**
     * Source ID related to the follow action
     * @type {string}
     * @memberof ApiUserFollowRequest
     */
    'sourceId'?: string;
}

export const ApiUserFollowRequestSourceEnum = {
    Chat: 'chat',
    Group: 'group',
    Profile: 'profile'
} as const;

export type ApiUserFollowRequestSourceEnum = typeof ApiUserFollowRequestSourceEnum[keyof typeof ApiUserFollowRequestSourceEnum];

/**
 * 
 * @export
 * @interface ApiUserRelationsBlock401Response
 */
export interface ApiUserRelationsBlock401Response {
    /**
     * Wrong or Expired Session
     * @type {string}
     * @memberof ApiUserRelationsBlock401Response
     */
    'errors': string;
}
/**
 * 
 * @export
 * @interface AppWidgetsResponse
 */
export interface AppWidgetsResponse {
    /**
     * 
     * @type {AppWidgetsResponseRelevantGroups}
     * @memberof AppWidgetsResponse
     */
    'relevantGroups'?: AppWidgetsResponseRelevantGroups;
    /**
     * 
     * @type {MapPreviewWidget}
     * @memberof AppWidgetsResponse
     */
    'mapPreview'?: MapPreviewWidget;
}
/**
 * Api items for app home relevant groups widget
 * @export
 * @interface AppWidgetsResponseRelevantGroups
 */
export interface AppWidgetsResponseRelevantGroups {
    /**
     * 
     * @type {string}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'title'?: string;
    /**
     * 
     * @type {Array<RelevantGroup>}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'groups'?: Array<RelevantGroup>;
}
/**
 * At location group participant statistics object
 * @export
 * @interface AtLocationGroupParticipantStatistics
 */
export interface AtLocationGroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
}
/**
 * chat base image
 * @export
 * @interface BaseImage
 */
export interface BaseImage {
    /**
     * 
     * @type {number}
     * @memberof BaseImage
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseImage
     */
    'url'?: string | null;
}
/**
 * base chat message
 * @export
 * @interface BaseMessage
 */
export interface BaseMessage {
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof BaseMessage
     */
    'createdBy': ChatConversationParticipant | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof BaseMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isEdited': boolean;
}
/**
 * 
 * @export
 * @interface BookingInfo
 */
export interface BookingInfo {
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerAgeRange'?: string | null;
}
/**
 * Chat contact object
 * @export
 * @interface ChatContact
 */
export interface ChatContact {
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'lastActionAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'association'?: string;
    /**
     * 
     * @type {UserStatistics}
     * @memberof ChatContact
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationCreate
 */
export interface ChatConversationCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationCreate
     */
    'userUuids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationCreate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationCreate
     */
    'groupIdInitiatedFrom'?: number | null;
}
/**
 * 
 * @export
 * @interface ChatConversationCreateImage
 */
export interface ChatConversationCreateImage {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreateImage
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationLeave
 */
export interface ChatConversationLeave {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationLeave
     */
    'newOwnerUuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationParticipant
 */
export interface ChatConversationParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'avatar': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isCurrentUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'activeState': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'gender': string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationUpdate
 */
export interface ChatConversationUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationUpdate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationUpdate
     */
    'userUuids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChatInit
 */
export interface ChatInit {
    /**
     * 
     * @type {string}
     * @memberof ChatInit
     */
    'groupId'?: string;
}
/**
 * chat last message
 * @export
 * @interface ChatLastMessage
 */
export interface ChatLastMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'key'?: string;
    /**
     * 
     * @type {ChatParticipant}
     * @memberof ChatLastMessage
     */
    'ownedBy'?: ChatParticipant | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'sentAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'updatedAt'?: number | null;
    /**
     * 
     * @type {MessageImages}
     * @memberof ChatLastMessage
     */
    'images'?: MessageImages;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isEdited'?: boolean;
}
/**
 * chat message
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ChatMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'type': ChatMessageTypeEnum;
    /**
     * 
     * @type {ReferencedMessage}
     * @memberof ChatMessage
     */
    'referencedMessage': ReferencedMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof ChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
}

export const ChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type ChatMessageTypeEnum = typeof ChatMessageTypeEnum[keyof typeof ChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface ChatMessageAllOfReactionCount
 */
export interface ChatMessageAllOfReactionCount {
    [key: string]: number | any;

    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'dislike'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'like'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'love'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'laugh'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'hushed'?: number;
}
/**
 * 
 * @export
 * @interface ChatMessageBase
 */
export interface ChatMessageBase {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChatMessageBaseImagesInner>}
     * @memberof ChatMessageBase
     */
    'images'?: Array<ChatMessageBaseImagesInner> | null;
}
/**
 * 
 * @export
 * @interface ChatMessageBaseImagesInner
 */
export interface ChatMessageBaseImagesInner {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBaseImagesInner
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageCreate
 */
export interface ChatMessageCreate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChatMessageBaseImagesInner>}
     * @memberof ChatMessageCreate
     */
    'images'?: Array<ChatMessageBaseImagesInner> | null;
}
/**
 * list of chat messages
 * @export
 * @interface ChatMessageList
 */
export interface ChatMessageList {
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ChatMessageList
     */
    'messages'?: Array<ChatMessage>;
}
/**
 * 
 * @export
 * @interface ChatMessageMarkAsSeen
 */
export interface ChatMessageMarkAsSeen {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'messageId'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageUpdate
 */
export interface ChatMessageUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<ChatMessageBaseImagesInner>}
     * @memberof ChatMessageUpdate
     */
    'images'?: Array<ChatMessageBaseImagesInner> | null;
}
/**
 * 
 * @export
 * @interface ChatParticipant
 */
export interface ChatParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipant
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'gender'?: string | null;
}
/**
 * chat conversation with messages
 * @export
 * @interface ChatWithMessages
 */
export interface ChatWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'key'?: string;
    /**
     * 
     * @type {ChatParticipant}
     * @memberof ChatWithMessages
     */
    'ownedBy'?: ChatParticipant | null;
    /**
     * 
     * @type {BaseImage}
     * @memberof ChatWithMessages
     */
    'image'?: BaseImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'participantsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'lastSeenTimestamp'?: number | null;
    /**
     * 
     * @type {ChatLastMessage}
     * @memberof ChatWithMessages
     */
    'lastMessage'?: ChatLastMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatWithMessages
     */
    'isNotificationEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithCursor
 */
export interface ChecktokCommentWithCursor {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithCursor
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithCursor
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithCursor
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithCursor
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithCursor
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'cursor'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithSuspendedDeleted
 */
export interface ChecktokCommentWithSuspendedDeleted {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'images'?: Array<ChecktokImage>;
}
/**
 * 
 * @export
 * @interface ChecktokImage
 */
export interface ChecktokImage {
    /**
     * 
     * @type {number}
     * @memberof ChecktokImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokReferencedComment
 */
export interface ChecktokReferencedComment {
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokReferencedComment
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokReferencedComment
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ChecktokReferencedComment
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface ChecktokStory
 */
export interface ChecktokStory {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStory
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStory
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStory
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStory
     */
    'metadata'?: ChecktokStoryMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryAuthenticatedUserMetadata
 */
export interface ChecktokStoryAuthenticatedUserMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'shareCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userCommented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userReaction'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryComments
 */
export interface ChecktokStoryComments {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryComments
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryFilter
 */
export interface ChecktokStoryFilter {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryFilter
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryFilter
     */
    'storyCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForArchive
 */
export interface ChecktokStoryForArchive {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForArchive
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForArchive
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForArchive
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStoryForArchive
     */
    'metadata'?: ChecktokStoryMetadata;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'watchUrl'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForAuthenticatedUser
 */
export interface ChecktokStoryForAuthenticatedUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryAuthenticatedUserMetadata}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'metadata'?: ChecktokStoryAuthenticatedUserMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryMetadata
 */
export interface ChecktokStoryMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'shareCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryThumbnails
 */
export interface ChecktokStoryThumbnails {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'original'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'firstFrame'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokTrackingEvent
 */
export interface ChecktokTrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'guidDevice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventName'?: ChecktokTrackingEventEventNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventSession'?: string;
    /**
     * 
     * @type {ChecktokTrackingValue}
     * @memberof ChecktokTrackingEvent
     */
    'eventValue'?: ChecktokTrackingValue;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appSession'?: string | null;
}

export const ChecktokTrackingEventEventNameEnum = {
    VideoStart: 'videoStart',
    VideoPause: 'videoPause',
    VideoResume: 'videoResume',
    VideoFinish: 'videoFinish',
    VideoExit: 'videoExit',
    VideoReplay: 'videoReplay',
    VideoCtaClick: 'videoCtaClick'
} as const;

export type ChecktokTrackingEventEventNameEnum = typeof ChecktokTrackingEventEventNameEnum[keyof typeof ChecktokTrackingEventEventNameEnum];

/**
 * 
 * @export
 * @interface ChecktokTrackingValue
 */
export interface ChecktokTrackingValue {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'storyId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokUser
 */
export interface ChecktokUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokUser
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'activeState'?: string;
}
/**
 * 
 * @export
 * @interface CommentDeletedInfo
 */
export interface CommentDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface CommentLocationInfo
 */
export interface CommentLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface CommentReferencedInfo
 */
export interface CommentReferencedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentReferencedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentReferencedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'communityLink'?: string;
}
/**
 * 
 * @export
 * @interface CommentUpdatedInfo
 */
export interface CommentUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {CommentLocationInfo}
     * @memberof CommentUpdatedInfo
     */
    'location'?: CommentLocationInfo | null;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<CommentUpdatedInfoReactionCountInner>}
     * @memberof CommentUpdatedInfo
     */
    'reactionCount'?: Array<CommentUpdatedInfoReactionCountInner>;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'communityLink'?: string;
    /**
     * 
     * @type {CommentReferencedInfo}
     * @memberof CommentUpdatedInfo
     */
    'referencedComment'?: CommentReferencedInfo | null;
}
/**
 * 
 * @export
 * @interface CommentUpdatedInfoReactionCountInner
 */
export interface CommentUpdatedInfoReactionCountInner {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionCount'?: number;
}
/**
 * 
 * @export
 * @interface CommunityGlobalConfigs200Response
 */
export interface CommunityGlobalConfigs200Response {
    /**
     * 
     * @type {Array<CoreGlobalConfigItem>}
     * @memberof CommunityGlobalConfigs200Response
     */
    'configs': Array<CoreGlobalConfigItem>;
}
/**
 * 
 * @export
 * @interface CommunityMediaList200Response
 */
export interface CommunityMediaList200Response {
    /**
     * 
     * @type {Array<CoreMediaItem>}
     * @memberof CommunityMediaList200Response
     */
    'images'?: Array<CoreMediaItem>;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestGroupCategoryItem
 */
export interface CommunityPointOfInterestGroupCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'icon'?: string;
    /**
     * 
     * @type {Array<CommunityPointOfInterestModel>}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'pointOfInterestModels'?: Array<CommunityPointOfInterestModel>;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestModel
 */
export interface CommunityPointOfInterestModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestModel
     */
    'name'?: string;
    /**
     * 
     * @type {CommunityPointOfInterestTypeModel}
     * @memberof CommunityPointOfInterestModel
     */
    'pointOfInterestTypeModel'?: CommunityPointOfInterestTypeModel;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'distanceInKilometers'?: number | null;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestTypeModel
 */
export interface CommunityPointOfInterestTypeModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'displayName'?: string;
}
/**
 * image external api
 * @export
 * @interface ConversationImageExternal
 */
export interface ConversationImageExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'small'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'big'?: string | null;
}
/**
 * link for external api
 * @export
 * @interface ConversationLinkExternal
 */
export interface ConversationLinkExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'desktop'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tablet'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tabletapp'?: string;
}
/**
 * chat conversations list
 * @export
 * @interface ConversationList
 */
export interface ConversationList {
    /**
     * 
     * @type {Array<ConversationWithMessages>}
     * @memberof ConversationList
     */
    'result': Array<ConversationWithMessages>;
    /**
     * 
     * @type {ConversationListMeta}
     * @memberof ConversationList
     */
    'meta': ConversationListMeta;
}
/**
 * 
 * @export
 * @interface ConversationListMeta
 */
export interface ConversationListMeta {
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'prev'?: string;
}
/**
 * metadata for external api
 * @export
 * @interface ConversationMetadataExternal
 */
export interface ConversationMetadataExternal {
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'totalCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'firstUnreadAnchor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'latestMessageId'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationParticipantsList200Response
 */
export interface ConversationParticipantsList200Response {
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ConversationParticipantsList200Response
     */
    'result': Array<ChatConversationParticipant>;
}
/**
 * 
 * @export
 * @interface ConversationParticipantsNotificationUpdateRequest
 */
export interface ConversationParticipantsNotificationUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ConversationParticipantsNotificationUpdateRequest
     */
    'enable'?: boolean;
}
/**
 * conversation related group
 * @export
 * @interface ConversationRelatedGroup
 */
export interface ConversationRelatedGroup {
    /**
     * 
     * @type {number}
     * @memberof ConversationRelatedGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ConversationRelatedGroup
     */
    'name': string;
}
/**
 * chat conversation with last two messages
 * @export
 * @interface ConversationWithLastMessages
 */
export interface ConversationWithLastMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'messagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ConversationWithLastMessages
     */
    'lastMessages'?: Array<ChatMessage>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'displayDate'?: string;
}
/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessages
 */
export interface ConversationWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ConversationWithMessages
     */
    'ownedBy': ChatConversationParticipant | null;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ConversationWithMessages
     */
    'participants': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'participantsCount': number;
    /**
     * 
     * @type {ApiGroupSuggest200ResponseGroupsInnerImage}
     * @memberof ConversationWithMessages
     */
    'image': ApiGroupSuggest200ResponseGroupsInnerImage;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'type': ConversationWithMessagesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'subtype': ConversationWithMessagesSubtypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isOwner': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'messagesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'unreadCount': number;
    /**
     * 
     * @type {ChatMessage}
     * @memberof ConversationWithMessages
     */
    'lastMessage': ChatMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'displayDate': string;
    /**
     * 
     * @type {ConversationRelatedGroup}
     * @memberof ConversationWithMessages
     */
    'relatedGroup': ConversationRelatedGroup | null;
}

export const ConversationWithMessagesTypeEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationWithMessagesTypeEnum = typeof ConversationWithMessagesTypeEnum[keyof typeof ConversationWithMessagesTypeEnum];
export const ConversationWithMessagesSubtypeEnum = {
    Country: 'country',
    City: 'city',
    Hotel: 'hotel',
    Region: 'region'
} as const;

export type ConversationWithMessagesSubtypeEnum = typeof ConversationWithMessagesSubtypeEnum[keyof typeof ConversationWithMessagesSubtypeEnum];

/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessagesExternal
 */
export interface ConversationWithMessagesExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'preview'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'partner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'type'?: string;
    /**
     * 
     * @type {ConversationLinkExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'link'?: ConversationLinkExternal;
    /**
     * 
     * @type {ConversationImageExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'image'?: ConversationImageExternal | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {ConversationMetadataExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'metaData'?: ConversationMetadataExternal;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationWithMessagesExternal
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'activity'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationsListRequest
 */
export interface ConversationsListRequest {
    /**
     * get chats of specific type
     * @type {Array<string>}
     * @memberof ConversationsListRequest
     */
    'types'?: Array<ConversationsListRequestTypesEnum>;
    /**
     * default: 20, max: 50
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'after'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'before'?: number | null;
    /**
     * get updates after specified timestamp
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'diff'?: number | null;
    /**
     * get chats with unread messages
     * @type {boolean}
     * @memberof ConversationsListRequest
     */
    'unreadOnly'?: boolean | null;
}

export const ConversationsListRequestTypesEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationsListRequestTypesEnum = typeof ConversationsListRequestTypesEnum[keyof typeof ConversationsListRequestTypesEnum];

/**
 * 
 * @export
 * @interface CoreAuthorAttributedImageItem
 */
export interface CoreAuthorAttributedImageItem {
    /**
     * 
     * @type {number}
     * @memberof CoreAuthorAttributedImageItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface CoreFile
 */
export interface CoreFile {
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'bucket'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'thumbnail'?: string;
}
/**
 * 
 * @export
 * @interface CoreGlobalConfigItem
 */
export interface CoreGlobalConfigItem {
    /**
     * 
     * @type {string}
     * @memberof CoreGlobalConfigItem
     */
    'name': string;
    /**
     * 
     * @type {CoreGlobalConfigItemValue}
     * @memberof CoreGlobalConfigItem
     */
    'value': CoreGlobalConfigItemValue;
}
/**
 * @type CoreGlobalConfigItemValue
 * @export
 */
export type CoreGlobalConfigItemValue = boolean | number | string;

/**
 * 
 * @export
 * @interface CoreMediaItem
 */
export interface CoreMediaItem {
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'postId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'commentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'cursor'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'imageUrl'?: string;
}
/**
 * shortened url
 * @export
 * @interface CoreShortUrl
 */
export interface CoreShortUrl {
    /**
     * 
     * @type {number}
     * @memberof CoreShortUrl
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'long'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'short'?: string;
}
/**
 * Experience information
 * @export
 * @interface Experience
 */
export interface Experience {
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingAverage': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingCount': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'distanceInKilometers': number | null;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof Experience
     */
    'freeCancellation': boolean;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'travelersInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface ExperiencesList
 */
export interface ExperiencesList {
    /**
     * 
     * @type {Array<Experience>}
     * @memberof ExperiencesList
     */
    'result': Array<Experience>;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'searchLink': string;
}
/**
 * 
 * @export
 * @interface ExternalConversationsListRequest
 */
export interface ExternalConversationsListRequest {
    /**
     * 
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'userId'?: number;
    /**
     * default: 20, max: 200
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * default: 20, max: 50
     * @type {Array<string>}
     * @memberof ExternalConversationsListRequest
     */
    'orderBy'?: Array<ExternalConversationsListRequestOrderByEnum> | null;
    /**
     * 
     * @type {ExternalConversationsListRequestTags}
     * @memberof ExternalConversationsListRequest
     */
    'tags'?: ExternalConversationsListRequestTags | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'after'?: string | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'before'?: string | null;
}

export const ExternalConversationsListRequestOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type ExternalConversationsListRequestOrderByEnum = typeof ExternalConversationsListRequestOrderByEnum[keyof typeof ExternalConversationsListRequestOrderByEnum];

/**
 * tags of a conversation
 * @export
 * @interface ExternalConversationsListRequestTags
 */
export interface ExternalConversationsListRequestTags {
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'value'?: string;
}
/**
 * External group object
 * @export
 * @interface ExternalGroup
 */
export interface ExternalGroup {
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'object_key'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'group_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'travel_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'travel_count_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'post_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_author_attribution'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExternalGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_url'?: string;
}
/**
 * 
 * @export
 * @interface ExternalGroupDetailsRequest
 */
export interface ExternalGroupDetailsRequest {
    /**
     * Community group ID
     * @type {number}
     * @memberof ExternalGroupDetailsRequest
     */
    'groupId'?: number;
}
/**
 * External group details result
 * @export
 * @interface ExternalGroupDetailsResult
 */
export interface ExternalGroupDetailsResult {
    /**
     * Group subline (typically member count)
     * @type {string}
     * @memberof ExternalGroupDetailsResult
     */
    'subline'?: string;
    /**
     * List of member avatar URLs
     * @type {Array<string>}
     * @memberof ExternalGroupDetailsResult
     */
    'avatars'?: Array<string>;
}
/**
 * External group object
 * @export
 * @interface ExternalHotelRelatedGroups
 */
export interface ExternalHotelRelatedGroups {
    /**
     * 
     * @type {number}
     * @memberof ExternalHotelRelatedGroups
     */
    'hotel_id'?: number;
    /**
     * 
     * @type {Array<ExternalGroup>}
     * @memberof ExternalHotelRelatedGroups
     */
    'groups'?: Array<ExternalGroup>;
}
/**
 * List of users following another user
 * @export
 * @interface FollowersList
 */
export interface FollowersList {
    /**
     * 
     * @type {number}
     * @memberof FollowersList
     */
    'totalCount': number;
    /**
     * 
     * @type {Array<UserProfile>}
     * @memberof FollowersList
     */
    'data': Array<UserProfile>;
    /**
     * 
     * @type {string}
     * @memberof FollowersList
     */
    'cursor': string | null;
}
/**
 * Generated answer object
 * @export
 * @interface GeneratedAnswer
 */
export interface GeneratedAnswer {
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'suggestionText'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'topics'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'suggestedAnswers'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'chips'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'updatedAt'?: string;
}
/**
 * Alternative group for post creation
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'imageAuthorAttribution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'geoLong': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'regionName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'countryName': string | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'starRatingOfficial': boolean | null;
}
/**
 * Group details
 * @export
 * @interface GroupDetailsType
 */
export interface GroupDetailsType {
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'type': GroupDetailsTypeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'activeBooking': boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingEnd': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingLabel': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'atLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isMember': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'hasImages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'hasRatings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isJoined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'viewCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'postsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'parentPostsCount': number;
    /**
     * 
     * @type {Array<GroupLink>}
     * @memberof GroupDetailsType
     */
    'links': Array<GroupLink>;
}

export const GroupDetailsTypeTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupDetailsTypeTypeEnum = typeof GroupDetailsTypeTypeEnum[keyof typeof GroupDetailsTypeTypeEnum];

/**
 * 
 * @export
 * @interface GroupInfo
 */
export interface GroupInfo {
    /**
     * 
     * @type {number}
     * @memberof GroupInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'travelLocationId'?: string | null;
    /**
     * 
     * @type {Array<PointOfInterestInfo>}
     * @memberof GroupInfo
     */
    'pois'?: Array<PointOfInterestInfo>;
}
/**
 * Group details link type
 * @export
 * @interface GroupLink
 */
export interface GroupLink {
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'url': string;
}
/**
 * Group Participant filter
 * @export
 * @interface GroupParticipantFilter
 */
export interface GroupParticipantFilter {
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'type': GroupParticipantFilterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'name': GroupParticipantFilterNameEnum;
    /**
     * 
     * @type {object}
     * @memberof GroupParticipantFilter
     */
    'criteria': object;
    /**
     * 
     * @type {boolean}
     * @memberof GroupParticipantFilter
     */
    'default': boolean;
}

export const GroupParticipantFilterTypeEnum = {
    All: 'ALL',
    AtLocation: 'AT_LOCATION',
    ActiveCategory: 'ACTIVE_CATEGORY'
} as const;

export type GroupParticipantFilterTypeEnum = typeof GroupParticipantFilterTypeEnum[keyof typeof GroupParticipantFilterTypeEnum];
export const GroupParticipantFilterNameEnum = {
    AtLocation: 'AT_LOCATION',
    CustomRange: 'CUSTOM_RANGE',
    HasUpcomingBooking: 'HAS_UPCOMING_BOOKING',
    AllowContact: 'ALLOW_CONTACT',
    Online: 'ONLINE',
    Engaged: 'ENGAGED',
    Insider: 'INSIDER',
    New: 'NEW'
} as const;

export type GroupParticipantFilterNameEnum = typeof GroupParticipantFilterNameEnum[keyof typeof GroupParticipantFilterNameEnum];

/**
 * At location group participant statistics object
 * @export
 * @interface GroupParticipantStatistics
 */
export interface GroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'engagementScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'experienceScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupParticipantStatistics
     */
    'atLocation'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupParticipantsFilters400Response
 */
export interface GroupParticipantsFilters400Response {
    /**
     * 
     * @type {object}
     * @memberof GroupParticipantsFilters400Response
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface GroupPointsOfInterest200ResponseInner
 */
export interface GroupPointsOfInterest200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {Array<GroupPointsOfInterest200ResponseInnerItemsInner>}
     * @memberof GroupPointsOfInterest200ResponseInner
     */
    'items': Array<GroupPointsOfInterest200ResponseInnerItemsInner>;
}
/**
 * 
 * @export
 * @interface GroupPointsOfInterest200ResponseInnerItemsInner
 */
export interface GroupPointsOfInterest200ResponseInnerItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'name': string;
    /**
     * 
     * @type {GroupPointsOfInterest200ResponseInnerItemsInnerType}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'type': GroupPointsOfInterest200ResponseInnerItemsInnerType;
    /**
     * 
     * @type {number}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'geoLat': number;
    /**
     * 
     * @type {number}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'geoLong': number;
    /**
     * 
     * @type {number}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInner
     */
    'distanceInKilometers': number | null;
}
/**
 * 
 * @export
 * @interface GroupPointsOfInterest200ResponseInnerItemsInnerType
 */
export interface GroupPointsOfInterest200ResponseInnerItemsInnerType {
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInnerType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInnerType
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof GroupPointsOfInterest200ResponseInnerItemsInnerType
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface GroupRatingsGet200Response
 */
export interface GroupRatingsGet200Response {
    /**
     * 
     * @type {number}
     * @memberof GroupRatingsGet200Response
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupRatingsGet200Response
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRatingsGet200Response
     */
    'parentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRatingsGet200Response
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRatingsGet200Response
     */
    'imageAuthorAttribution'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRatingsGet200Response
     */
    'type'?: string;
}
/**
 * Group search item object
 * @export
 * @interface GroupSearchItem
 */
export interface GroupSearchItem {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'coverImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'popularityTier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'category'?: number | null;
    /**
     * 
     * @type {Array<GroupSearchItemGeoPointInner>}
     * @memberof GroupSearchItem
     */
    'geoPoint'?: Array<GroupSearchItemGeoPointInner> | null;
}
/**
 * 
 * @export
 * @interface GroupSearchItemGeoPointInner
 */
export interface GroupSearchItemGeoPointInner {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lon'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lat'?: number;
}
/**
 * This schema returned used for suggested group
 * @export
 * @interface GroupSuggestion
 */
export interface GroupSuggestion {
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'type': GroupSuggestionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupSuggestion
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupSuggestion
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'countryName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'regionName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'distanceInKilometers': number;
    /**
     * 
     * @type {Array<PublicProfile>}
     * @memberof GroupSuggestion
     */
    'topParticipants': Array<PublicProfile>;
}

export const GroupSuggestionTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupSuggestionTypeEnum = typeof GroupSuggestionTypeEnum[keyof typeof GroupSuggestionTypeEnum];

/**
 * 
 * @export
 * @interface GroupTopParticipants200Response
 */
export interface GroupTopParticipants200Response {
    /**
     * 
     * @type {Array<TopParticipantUser>}
     * @memberof GroupTopParticipants200Response
     */
    'topParticipants': Array<TopParticipantUser>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GroupTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupTypeEnum = typeof GroupTypeEnum[keyof typeof GroupTypeEnum];


/**
 * chat image
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ImageInfo
 */
export interface ImageInfo {
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'authorAttribution'?: string | null;
}
/**
 * chat init data
 * @export
 * @interface InitData
 */
export interface InitData {
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'alreadyVisited'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof InitData
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'isNotificationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'hasAtleastOneMessage'?: boolean;
}
/**
 * 
 * @export
 * @interface LotteryStop
 */
export interface LotteryStop {
    /**
     * 
     * @type {string}
     * @memberof LotteryStop
     */
    'id'?: string;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof LotteryStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {number}
     * @memberof LotteryStop
     */
    'possible_prizes_per_user'?: number | null;
    /**
     * 
     * @type {Array<StopPrizeItem>}
     * @memberof LotteryStop
     */
    'prize_items'?: Array<StopPrizeItem>;
}
/**
 * map coordinates
 * @export
 * @interface MapCoordinate
 */
export interface MapCoordinate {
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'long': number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfig
 */
export interface MapPreviewConfig {
    /**
     * 
     * @type {MapPreviewConfigCenter}
     * @memberof MapPreviewConfig
     */
    'center'?: MapPreviewConfigCenter;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfig
     */
    'zoom'?: number;
    /**
     * 
     * @type {MapPreviewConfigBounds}
     * @memberof MapPreviewConfig
     */
    'bounds'?: MapPreviewConfigBounds;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigBounds
 */
export interface MapPreviewConfigBounds {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'n'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'w'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    's'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'e'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigCenter
 */
export interface MapPreviewConfigCenter {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewGroup
 */
export interface MapPreviewGroup {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof MapPreviewGroup
     */
    'iconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface MapPreviewWidget
 */
export interface MapPreviewWidget {
    /**
     * 
     * @type {MapPreviewConfig}
     * @memberof MapPreviewWidget
     */
    'map'?: MapPreviewConfig;
    /**
     * 
     * @type {Array<MapPreviewGroup>}
     * @memberof MapPreviewWidget
     */
    'groups'?: Array<MapPreviewGroup>;
}
/**
 * chat image
 * @export
 * @interface MessageImages
 */
export interface MessageImages {
    /**
     * 
     * @type {Array<Image>}
     * @memberof MessageImages
     */
    'images'?: Array<Image>;
}
/**
 * conversation messages list
 * @export
 * @interface MessageList
 */
export interface MessageList {
    /**
     * 
     * @type {Array<UserChatMessage>}
     * @memberof MessageList
     */
    'result'?: Array<UserChatMessage>;
    /**
     * 
     * @type {number}
     * @memberof MessageList
     */
    'pollingInterval'?: number;
}
/**
 * News widget item
 * @export
 * @interface NewsWidgetItem
 */
export interface NewsWidgetItem {
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'type'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof NewsWidgetItem
     */
    'itemId'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasImage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasLink'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'messageCount'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NewsWidgetItem
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof NewsWidgetItem
     */
    'userReactions'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'commentCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationInputNewsFeedInput
 */
export interface NotificationInputNewsFeedInput {
    /**
     * List of newsId\'s (uuid)
     * @type {Array<string>}
     * @memberof NotificationInputNewsFeedInput
     */
    'newsIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NotificationMultiUserImageInternalNotification
 */
export interface NotificationMultiUserImageInternalNotification {
    /**
     * 
     * @type {number}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'previewImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'classification'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'displayDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'users'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'seenAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedMeta
 */
export interface NotificationNewsFeedMeta {
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'unread'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedNewsFeedAdd
 */
export interface NotificationNewsFeedNewsFeedAdd {
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'news_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'subline'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'image_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'target_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'product'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'is_read'?: boolean;
}
/**
 * User notification settings object
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPush'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationComment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationLike'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPrivateMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationGroupMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPublicMessage'?: boolean;
}
/**
 * 
 * @export
 * @interface PointOfInterestInfo
 */
export interface PointOfInterestInfo {
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PointOfInterestInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PointOfInterestInfo
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface PollOptionInfo
 */
export interface PollOptionInfo {
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PollOptionInfo
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'responseCount'?: number;
}
/**
 * 
 * @export
 * @interface PostCreateRequest
 */
export interface PostCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'content': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostCreateRequest
     */
    'isQuestion': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'sourceType': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'location': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostCreateRequest
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof PostCreateRequest
     */
    'geoLong': number | null;
    /**
     * 
     * @type {Array<ChatMessageBaseImagesInner>}
     * @memberof PostCreateRequest
     */
    'imageList': Array<ChatMessageBaseImagesInner> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostCreateRequest
     */
    'repostToChats': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'pollType': string | null;
    /**
     * 
     * @type {Array<PostCreateRequestPollOptionsInner>}
     * @memberof PostCreateRequest
     */
    'pollOptions': Array<PostCreateRequestPollOptionsInner> | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'pollClosedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'locationId': string | null;
}
/**
 * 
 * @export
 * @interface PostCreateRequestPollOptionsInner
 */
export interface PostCreateRequestPollOptionsInner {
    /**
     * 
     * @type {boolean}
     * @memberof PostCreateRequestPollOptionsInner
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequestPollOptionsInner
     */
    'content'?: string;
}
/**
 * 
 * @export
 * @interface PostCreateResponse
 */
export interface PostCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof PostCreateResponse
     */
    'message': string;
    /**
     * ID of the created post
     * @type {number}
     * @memberof PostCreateResponse
     */
    'postId': number;
}
/**
 * 
 * @export
 * @interface PostDeletedInfo
 */
export interface PostDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInner
 */
export interface PostListResponsePropertyInner {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'id'?: number;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroup}
     * @memberof PostListResponsePropertyInner
     */
    'group'?: PostListResponsePropertyInnerGroup;
    /**
     * 
     * @type {PostListResponsePropertyInnerUser}
     * @memberof PostListResponsePropertyInner
     */
    'user'?: PostListResponsePropertyInnerUser;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'suspendedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'releasedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'releasedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'location'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'commentCount'?: number;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerImagesInner>}
     * @memberof PostListResponsePropertyInner
     */
    'images'?: Array<PostListResponsePropertyInnerImagesInner>;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerVideosInner>}
     * @memberof PostListResponsePropertyInner
     */
    'videos'?: Array<PostListResponsePropertyInnerVideosInner>;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroup
 */
export interface PostListResponsePropertyInnerGroup {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroup
     * @deprecated
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'image': string;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroupLocation}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'location': PostListResponsePropertyInnerGroupLocation;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroupLocation
 */
export interface PostListResponsePropertyInnerGroupLocation {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLat': number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLong': number;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerImagesInner
 */
export interface PostListResponsePropertyInnerImagesInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerImagesInner
     */
    'imageURI'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerUser
 */
export interface PostListResponsePropertyInnerUser {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerUser
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerVideosInner
 */
export interface PostListResponsePropertyInnerVideosInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerVideosInner
     */
    'videoUri'?: string;
}
/**
 * 
 * @export
 * @interface PostLocationInfo
 */
export interface PostLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface PostPollInfo
 */
export interface PostPollInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostPollInfo
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostPollInfo
     */
    'closedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface PostUpdateRequest
 */
export interface PostUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'content': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostUpdateRequest
     */
    'isQuestion'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequest
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequest
     */
    'geoLong'?: number | null;
    /**
     * 
     * @type {Array<PostUpdateRequestImageListInner>}
     * @memberof PostUpdateRequest
     */
    'imageList'?: Array<PostUpdateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface PostUpdateRequestImageListInner
 */
export interface PostUpdateRequestImageListInner {
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequestImageListInner
     */
    'id'?: number;
    /**
     * Storage key of the image
     * @type {string}
     * @memberof PostUpdateRequestImageListInner
     */
    'key'?: string;
    /**
     * Delete flag
     * @type {boolean}
     * @memberof PostUpdateRequestImageListInner
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface PostUpdateResponse
 */
export interface PostUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof PostUpdateResponse
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateResponse
     */
    'postId': number;
}
/**
 * 
 * @export
 * @interface PostUpdatedInfo
 */
export interface PostUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'askQuestionId'?: string | null;
    /**
     * 
     * @type {GroupInfo}
     * @memberof PostUpdatedInfo
     */
    'group'?: GroupInfo;
    /**
     * 
     * @type {UserInfo}
     * @memberof PostUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostUpdatedInfo
     */
    'isQuestion'?: boolean;
    /**
     * 
     * @type {PostLocationInfo}
     * @memberof PostUpdatedInfo
     */
    'location'?: PostLocationInfo | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'predictedTags'?: Array<string>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'videos'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'reactionCount'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {PostPollInfo}
     * @memberof PostUpdatedInfo
     */
    'poll'?: PostPollInfo | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'communityLink'?: string;
}
/**
 * User privacy settings object
 * @export
 * @interface PrivacySettings
 */
export interface PrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showPostCollection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInPublicSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInGroupSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showProfilePicture'?: boolean;
}
/**
 * 
 * @export
 * @interface PrivateStop
 */
export interface PrivateStop {
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof PrivateStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof PrivateStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PrivateStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PrivateStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrivateStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PrivateStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PrivateStop
     */
    'merch'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'type'?: PrivateStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'state'?: PrivateStopStateEnum;
}

export const PrivateStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type PrivateStopTypeEnum = typeof PrivateStopTypeEnum[keyof typeof PrivateStopTypeEnum];
export const PrivateStopStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type PrivateStopStateEnum = typeof PrivateStopStateEnum[keyof typeof PrivateStopStateEnum];

/**
 * Profile object
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fallbackAvatar'?: string;
    /**
     * 
     * @type {PrivacySettings}
     * @memberof Profile
     */
    'privacySettings'?: PrivacySettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof Profile
     */
    'notificationSettings'?: NotificationSettings;
    /**
     * 
     * @type {SessionUserStatistics}
     * @memberof Profile
     */
    'statistics'?: SessionUserStatistics;
}
/**
 * 
 * @export
 * @interface PromotedGroup
 */
export interface PromotedGroup {
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'type': PromotedGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'activeBooking': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'activeBookingStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'activeBookingLabel': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'atLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isMember': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'hasImages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'hasRatings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isJoined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'viewCount': number;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'postsCount': number;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'parentPostsCount': number;
    /**
     * 
     * @type {Array<GroupLink>}
     * @memberof PromotedGroup
     */
    'links': Array<GroupLink>;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'countryName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'regionName': string | null;
    /**
     * 
     * @type {Array<PublicProfile>}
     * @memberof PromotedGroup
     */
    'topParticipants': Array<PublicProfile>;
}

export const PromotedGroupTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type PromotedGroupTypeEnum = typeof PromotedGroupTypeEnum[keyof typeof PromotedGroupTypeEnum];

/**
 * User public privacy settings object
 * @export
 * @interface PublicPrivacySettings
 */
export interface PublicPrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'showPostCollection'?: boolean;
}
/**
 * Public profile object
 * @export
 * @interface PublicProfile
 */
export interface PublicProfile {
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {PublicPrivacySettings}
     * @memberof PublicProfile
     */
    'privacySettings'?: PublicPrivacySettings;
    /**
     * 
     * @type {UserStatistics}
     * @memberof PublicProfile
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface PublicStop
 */
export interface PublicStop {
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof PublicStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof PublicStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PublicStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PublicStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PublicStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PublicStop
     */
    'merch'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'type'?: PublicStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'state'?: PublicStopStateEnum;
}

export const PublicStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type PublicStopTypeEnum = typeof PublicStopTypeEnum[keyof typeof PublicStopTypeEnum];
export const PublicStopStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type PublicStopStateEnum = typeof PublicStopStateEnum[keyof typeof PublicStopStateEnum];

/**
 * 
 * @export
 * @interface ReactionUpdate
 */
export interface ReactionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'reactionTypeName'?: string;
}
/**
 * referenced chat message
 * @export
 * @interface ReferencedMessage
 */
export interface ReferencedMessage {
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ReferencedMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ReferencedMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isEdited': boolean;
}
/**
 * 
 * @export
 * @interface RelevantGroup
 */
export interface RelevantGroup {
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'travelCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'postCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'image'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelevantGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'imageAuthorAttribution'?: string | null;
}
/**
 * Current session user statistics object
 * @export
 * @interface SessionUserStatistics
 */
export interface SessionUserStatistics {
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'daysActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'totalScore'?: number;
}
/**
 * Simple user object
 * @export
 * @interface SimpleUser
 */
export interface SimpleUser {
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'avatar'?: string | null;
}
/**
 * 
 * @export
 * @interface StopPrizeItem
 */
export interface StopPrizeItem {
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'description'?: string;
    /**
     * 
     * @type {TruckPresentationHttpOutputPrizePrizeTypeEnum}
     * @memberof StopPrizeItem
     */
    'type'?: TruckPresentationHttpOutputPrizePrizeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'icon_image'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StopPrizeItem
     */
    'amount'?: number | null;
    /**
     * cs plan ID in case of type=voucher
     * @type {string}
     * @memberof StopPrizeItem
     */
    'additional_info'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TippspielGameResultEnum = {
    Win: 'win',
    Loss: 'loss',
    Draw: 'draw'
} as const;

export type TippspielGameResultEnum = typeof TippspielGameResultEnum[keyof typeof TippspielGameResultEnum];


/**
 * 
 * @export
 * @interface TippspielTeamHistories
 */
export interface TippspielTeamHistories {
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamHomeHistory'?: Array<TippspielTeamHistory>;
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamAwayHistory'?: Array<TippspielTeamHistory>;
}
/**
 * 
 * @export
 * @interface TippspielTeamHistory
 */
export interface TippspielTeamHistory {
    /**
     * 
     * @type {TippspielGameResultEnum}
     * @memberof TippspielTeamHistory
     */
    'gameResult'?: TippspielGameResultEnum;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'sportradarId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'gameStartsAt'?: string;
}


/**
 * 
 * @export
 * @interface TippspielUserUuidOutput
 */
export interface TippspielUserUuidOutput {
    /**
     * 
     * @type {string}
     * @memberof TippspielUserUuidOutput
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {TippspielUserUuidOutputInteractions}
     * @memberof TippspielUserUuidOutput
     */
    'interactions'?: TippspielUserUuidOutputInteractions;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface TippspielUserUuidOutputInteractions
 */
export interface TippspielUserUuidOutputInteractions {
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'polls'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'reactions'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'postsComments'?: any;
}
/**
 * Top participant user object
 * @export
 * @interface TopParticipantUser
 */
export interface TopParticipantUser {
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface TruckBadge
 */
export interface TruckBadge {
    /**
     * 
     * @type {boolean}
     * @memberof TruckBadge
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckBadge
     */
    'color'?: string | null;
    /**
     * 
     * @type {TruckDomainBadgeStateEnum}
     * @memberof TruckBadge
     */
    'state'?: TruckBadgeStateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TruckBadge
     */
    'textColor'?: string | null;
}

export const TruckBadgeStateEnum = {
    Date: 'date',
    Countdown: 'countdown',
    Live: 'live',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type TruckBadgeStateEnum = typeof TruckBadgeStateEnum[keyof typeof TruckBadgeStateEnum];

/**
 * 
 * @export
 * @interface TruckSearchStop
 */
export interface TruckSearchStop {
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'description': string;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckSearchStop
     */
    'location': TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckSearchStop
     */
    'application': TruckStopApplication;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'endDate': string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckSearchStop
     */
    'media': Array<TruckStopMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof TruckSearchStop
     */
    'level': number | null;
}
/**
 * 
 * @export
 * @interface TruckStop
 */
export interface TruckStop {
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'state'?: string;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStop
     */
    'garageLocation'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'type'?: TruckStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'stopId'?: string | null;
}

export const TruckStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type TruckStopTypeEnum = typeof TruckStopTypeEnum[keyof typeof TruckStopTypeEnum];

/**
 * 
 * @export
 * @interface TruckStopApplication
 */
export interface TruckStopApplication {
    /**
     * 
     * @type {boolean}
     * @memberof TruckStopApplication
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'subtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'ctaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopBanner
 */
export interface TruckStopBanner {
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'ctaUrl'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopComment
 */
export interface TruckStopComment {
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'content'?: string | null;
    /**
     * 
     * @type {TruckStopUser}
     * @memberof TruckStopComment
     */
    'user'?: TruckStopUser;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopConfig
 */
export interface TruckStopConfig {
    /**
     * 
     * @type {string}
     * @memberof TruckStopConfig
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopConfig
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopLocation
 */
export interface TruckStopLocation {
    /**
     * 
     * @type {string}
     * @memberof TruckStopLocation
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'radius'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'longitude'?: number;
}
/**
 * 
 * @export
 * @interface TruckStopMediaItem
 */
export interface TruckStopMediaItem {
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'type'?: TruckStopMediaItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'state'?: TruckStopMediaItemStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'thumbnail'?: string;
    /**
     * 
     * @type {TruckStopMetadata}
     * @memberof TruckStopMediaItem
     */
    'metadata'?: TruckStopMetadata;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMediaItem
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'commentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMediaItem
     */
    'itemCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'linkoutUrl'?: string | null;
}

export const TruckStopMediaItemTypeEnum = {
    Image: 'image',
    Video: 'video',
    Stream: 'stream',
    Countdown: 'countdown'
} as const;

export type TruckStopMediaItemTypeEnum = typeof TruckStopMediaItemTypeEnum[keyof typeof TruckStopMediaItemTypeEnum];
export const TruckStopMediaItemStateEnum = {
    None: 'none',
    Error: 'error',
    Interrupted: 'interrupted',
    Live: 'live'
} as const;

export type TruckStopMediaItemStateEnum = typeof TruckStopMediaItemStateEnum[keyof typeof TruckStopMediaItemStateEnum];

/**
 * 
 * @export
 * @interface TruckStopMetadata
 */
export interface TruckStopMetadata {
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'viewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'shareCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TruckStopMetadata
     */
    'userCommented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMetadata
     */
    'userReaction'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopUser
 */
export interface TruckStopUser {
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopWidget
 */
export interface TruckStopWidget {
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStopWidget
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStopWidget
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'information'?: string | null;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStopWidget
     */
    'badge'?: TruckBadge;
}
/**
 * User object
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'allowToContact'?: boolean;
}
/**
 * User achievement object
 * @export
 * @interface UserAchievement
 */
export interface UserAchievement {
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'criteria': number;
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAchievement
     */
    'isEarned': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'totalUsersCount': number;
}
/**
 * user chat message
 * @export
 * @interface UserChatMessage
 */
export interface UserChatMessage {
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof UserChatMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof UserChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'type': UserChatMessageTypeEnum;
    /**
     * 
     * @type {ReferencedMessage}
     * @memberof UserChatMessage
     */
    'referencedMessage': ReferencedMessage;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof UserChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof UserChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserChatMessage
     */
    'userReactions'?: Array<string>;
}

export const UserChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type UserChatMessageTypeEnum = typeof UserChatMessageTypeEnum[keyof typeof UserChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {number}
     * @memberof UserInfo
     */
    'ssoId'?: number;
    /**
     * 
     * @type {Array<BookingInfo>}
     * @memberof UserInfo
     */
    'bookings'?: Array<BookingInfo>;
}
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {User}
     * @memberof UserProfile
     */
    'user': User;
    /**
     * 
     * @type {UserRelationMetadata}
     * @memberof UserProfile
     */
    'metadata': UserRelationMetadata | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'reverseRelationState': UserProfileReverseRelationStateEnum | null;
}

export const UserProfileReverseRelationStateEnum = {
    Active: 'active',
    Blocked: 'blocked',
    None: 'none'
} as const;

export type UserProfileReverseRelationStateEnum = typeof UserProfileReverseRelationStateEnum[keyof typeof UserProfileReverseRelationStateEnum];

/**
 * 
 * @export
 * @interface UserRelationMetadata
 */
export interface UserRelationMetadata {
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'source'?: UserRelationMetadataSourceEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceType': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceName': string | null;
}

export const UserRelationMetadataSourceEnum = {
    Chat: 'chat',
    Group: 'group',
    Profile: 'profile'
} as const;

export type UserRelationMetadataSourceEnum = typeof UserRelationMetadataSourceEnum[keyof typeof UserRelationMetadataSourceEnum];

/**
 * Relationship details between two users
 * @export
 * @interface UserRelationship
 */
export interface UserRelationship {
    /**
     * 
     * @type {string}
     * @memberof UserRelationship
     */
    'state': UserRelationshipStateEnum;
    /**
     * 
     * @type {UserRelationMetadata}
     * @memberof UserRelationship
     */
    'metadata': UserRelationMetadata | null;
}

export const UserRelationshipStateEnum = {
    Active: 'active',
    Blocked: 'blocked',
    None: 'none'
} as const;

export type UserRelationshipStateEnum = typeof UserRelationshipStateEnum[keyof typeof UserRelationshipStateEnum];

/**
 * Relationship details between two users
 * @export
 * @interface UserRelationshipResult
 */
export interface UserRelationshipResult {
    /**
     * 
     * @type {UserRelationship}
     * @memberof UserRelationshipResult
     */
    'subject': UserRelationship;
    /**
     * 
     * @type {UserRelationship}
     * @memberof UserRelationshipResult
     */
    'follower': UserRelationship;
    /**
     * 
     * @type {User}
     * @memberof UserRelationshipResult
     */
    'user': User;
}
/**
 * User statistics object
 * @export
 * @interface UserStatistics
 */
export interface UserStatistics {
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'groupsJoinedCount'?: number;
}
/**
 * 
 * @export
 * @interface V1GroupParticipantsFilters200Response
 */
export interface V1GroupParticipantsFilters200Response {
    /**
     * 
     * @type {string}
     * @memberof V1GroupParticipantsFilters200Response
     * @deprecated
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof V1GroupParticipantsFilters200Response
     * @deprecated
     */
    'filters': Array<string>;
}
/**
 * 
 * @export
 * @interface V1GroupParticipantsFilters400Response
 */
export interface V1GroupParticipantsFilters400Response {
    /**
     * 
     * @type {object}
     * @memberof V1GroupParticipantsFilters400Response
     * @deprecated
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface WidgetOutput
 */
export interface WidgetOutput {
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'ctaText'?: string;
    /**
     * 
     * @type {Array<TruckStopWidget>}
     * @memberof WidgetOutput
     */
    'stops'?: Array<TruckStopWidget>;
    /**
     * 
     * @type {Array<TruckStopBanner>}
     * @memberof WidgetOutput
     */
    'banners'?: Array<TruckStopBanner>;
}

/**
 * CommunityApi - axios parameter creator
 * @export
 */
export const CommunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get backoffice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackofficeInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/backoffice-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get build information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBuildInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/build-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApiCommunityNotificationsAuthRequest} [apiCommunityNotificationsAuthRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityNotificationsAuth: async (apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/notifications/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiCommunityNotificationsAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provides a list of environments and their base urls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnvironmentsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/environment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all alternative groups for post creation
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupPostingAlternatives: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiGroupPostingAlternatives', 'id', id)
            const localVarPath = `/v2/community/groups/{id}/posting-alternatives`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Responds with a list of suggested groups.
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupSuggest: async (limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/groups/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Responds with a list of suggested groups.
         * @param {number} [limit] 
         * @param {number} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHotelSuggest: async (limit?: number, groupId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/hotels/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate referrer url
         * @param {ApiReferrerurlValidateRequest} [apiReferrerurlValidateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReferrerurlValidate: async (apiReferrerurlValidateRequest?: ApiReferrerurlValidateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/referrerurl/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiReferrerurlValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Response user highest earned or next
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAchievementsHighestEarnedOrNext: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserAchievementsHighestEarnedOrNext', 'id', id)
            const localVarPath = `/v2/community/user/achievements/highest-earned-or-next`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Response user achievements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAchievementsList: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserAchievementsList', 'id', id)
            const localVarPath = `/v2/community/user/achievements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow a user
         * @param {string} otherUserUuid ID of the user to follow
         * @param {ApiUserFollowRequest} [apiUserFollowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollow: async (otherUserUuid: string, apiUserFollowRequest?: ApiUserFollowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherUserUuid' is not null or undefined
            assertParamExists('apiUserFollow', 'otherUserUuid', otherUserUuid)
            const localVarPath = `/v2/community/users/{otherUserUuid}/follow`
                .replace(`{${"otherUserUuid"}}`, encodeURIComponent(String(otherUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiUserFollowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get users who follow the specified user
         * @param {string} uuid ID of the user
         * @param {number} [limit] Limit the number of results
         * @param {string} [cursor] Cursor for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollowersList: async (uuid: string, limit?: number, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiUserFollowersList', 'uuid', uuid)
            const localVarPath = `/v2/community/users/{uuid}/followers`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get users that the specified user follows
         * @param {string} uuid ID of the user
         * @param {number} [limit] Limit the number of results
         * @param {string} [cursor] Cursor for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollowingList: async (uuid: string, limit?: number, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiUserFollowingList', 'uuid', uuid)
            const localVarPath = `/v2/community/users/{uuid}/following`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} otherUserUuid ID of the user to block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationsBlock: async (otherUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherUserUuid' is not null or undefined
            assertParamExists('apiUserRelationsBlock', 'otherUserUuid', otherUserUuid)
            const localVarPath = `/v2/community/users/{otherUserUuid}/relationships/block`
                .replace(`{${"otherUserUuid"}}`, encodeURIComponent(String(otherUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} otherUserUuid ID of the user to unblock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationsUnblock: async (otherUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherUserUuid' is not null or undefined
            assertParamExists('apiUserRelationsUnblock', 'otherUserUuid', otherUserUuid)
            const localVarPath = `/v2/community/users/{otherUserUuid}/relationships/unblock`
                .replace(`{${"otherUserUuid"}}`, encodeURIComponent(String(otherUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get relationship details between two users
         * @param {string} otherUserUuid ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationshipDetails: async (otherUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherUserUuid' is not null or undefined
            assertParamExists('apiUserRelationshipDetails', 'otherUserUuid', otherUserUuid)
            const localVarPath = `/v2/community/users/{otherUserUuid}/relationships`
                .replace(`{${"otherUserUuid"}}`, encodeURIComponent(String(otherUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unfollow a user
         * @param {string} otherUserUuid ID of the user to unfollow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserUnfollow: async (otherUserUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otherUserUuid' is not null or undefined
            assertParamExists('apiUserUnfollow', 'otherUserUuid', otherUserUuid)
            const localVarPath = `/v2/community/users/{otherUserUuid}/unfollow`
                .replace(`{${"otherUserUuid"}}`, encodeURIComponent(String(otherUserUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityExperiences: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('communityExperiences', 'groupId', groupId)
            const localVarPath = `/v2/community/groups/{groupId}/experiences`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Community global configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityGlobalConfigs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/global-configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a List of all the Media (Images) assigned to the posts and comments of the group.
         * @param {string} groupId 
         * @param {string} [orderBy] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityGroupsMedia: async (groupId: string, orderBy?: string, offset?: string, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('communityGroupsMedia', 'groupId', groupId)
            const localVarPath = `/v2/community/groups/{groupId}/media`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieve media
         * @param {string} [groupId] 
         * @param {string} [limit] 
         * @param {string} [cursor] 
         * @param {string} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityMediaList: async (groupId?: string, limit?: string, cursor?: string, tags?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/media-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get relevant news for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityNews: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all valid conversation participants
         * @param {string} chatId 
         * @param {string} [limit] 
         * @param {string} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationParticipantsList: async (chatId: string, limit?: string, offset?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('conversationParticipantsList', 'chatId', chatId)
            const localVarPath = `/chat/conversations/{chatId}/participants`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update specific conversation participant notification setting
         * @param {string} id 
         * @param {ConversationParticipantsNotificationUpdateRequest} [conversationParticipantsNotificationUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationParticipantsNotificationUpdate: async (id: string, conversationParticipantsNotificationUpdateRequest?: ConversationParticipantsNotificationUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('conversationParticipantsNotificationUpdate', 'id', id)
            const localVarPath = `/chat/conversations/{id}/participants/notification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversationParticipantsNotificationUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * list conversations
         * @param {number | null} [limit] 
         * @param {number | null} [before] 
         * @param {number | null} [after] 
         * @param {number | null} [diff] 
         * @param {Array<ConversationsListTypesEnum>} [types] 
         * @param {boolean | null} [unreadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsList: async (limit?: number | null, before?: number | null, after?: number | null, diff?: number | null, types?: Array<ConversationsListTypesEnum>, unreadOnly?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/chat/conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (diff !== undefined) {
                localVarQueryParameter['diff'] = diff;
            }

            if (types) {
                localVarQueryParameter['types[]'] = types;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} groupId External group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalGroupDetails: async (groupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('externalGroupDetails', 'groupId', groupId)
            const localVarPath = `/v2/community/external/group/{groupId}/details`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieve base information for a single group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('groupDetails', 'id', id)
            const localVarPath = `/v2/community/groups/{id}/group-details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get avaiable Group participants filters
         * @param {string} groupId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParticipantsFilters: async (groupId: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('groupParticipantsFilters', 'groupId', groupId)
            const localVarPath = `/v3/community/groups/{groupId}/participants-filters`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieve points of interest for a group
         * @param {string} id 
         * @param {string} [location] 
         * @param {string} [groupId] 
         * @param {string} [radius] 
         * @param {string} [mapBound] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPointsOfInterest: async (id: string, location?: string, groupId?: string, radius?: string, mapBound?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('groupPointsOfInterest', 'id', id)
            const localVarPath = `/v2/community/search/poi`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }

            if (mapBound !== undefined) {
                localVarQueryParameter['map_bound'] = mapBound;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieve basic information required in the group rating page header
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRatingsGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('groupRatingsGet', 'id', id)
            const localVarPath = `/community/group-ratings/{id}/group-details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve top participants for a single group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupTopParticipants: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('groupTopParticipants', 'groupId', groupId)
            const localVarPath = `/community/groups/{groupId}/top-participants`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get groups using a text query
         * @param {string} [query] 
         * @param {boolean} [userGroups] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsByText: async (query?: string, userGroups?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/community/search/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (userGroups !== undefined) {
                localVarQueryParameter['userGroups'] = userGroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get avaiable Group participants filters
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GroupParticipantsFilters: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('v1GroupParticipantsFilters', 'groupId', groupId)
            const localVarPath = `/community/groups/{groupId}/participants-filters`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete user session
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ApiLogout: async (c24session: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('v2ApiLogout', 'c24session', c24session)
            const localVarPath = `/v2/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunityApi - functional programming interface
 * @export
 */
export const CommunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunityApiAxiosParamCreator(configuration)
    return {
        /**
         * Get backoffice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackofficeInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBackofficeInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackofficeInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiBackofficeInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get build information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBuildInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiBuildInformation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBuildInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiBuildInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ApiCommunityNotificationsAuthRequest} [apiCommunityNotificationsAuthRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityNotificationsAuth(apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityNotificationsAuth(apiCommunityNotificationsAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiCommunityNotificationsAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Provides a list of environments and their base urls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEnvironmentsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiEnvironmentsList200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEnvironmentsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiEnvironmentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all alternative groups for post creation
         * @param {string} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupPostingAlternatives(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGroupPostingAlternatives200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupPostingAlternatives(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiGroupPostingAlternatives']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Responds with a list of suggested groups.
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGroupSuggest(limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiGroupSuggest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGroupSuggest(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiGroupSuggest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Responds with a list of suggested groups.
         * @param {number} [limit] 
         * @param {number} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHotelSuggest(limit?: number, groupId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiHotelSuggest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHotelSuggest(limit, groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiHotelSuggest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate referrer url
         * @param {ApiReferrerurlValidateRequest} [apiReferrerurlValidateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReferrerurlValidate(apiReferrerurlValidateRequest?: ApiReferrerurlValidateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReferrerurlValidate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReferrerurlValidate(apiReferrerurlValidateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiReferrerurlValidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Response user highest earned or next
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAchievementsHighestEarnedOrNext(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserAchievementsHighestEarnedOrNext200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAchievementsHighestEarnedOrNext(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserAchievementsHighestEarnedOrNext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Response user achievements
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserAchievementsList(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUserAchievementsHighestEarnedOrNext200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserAchievementsList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserAchievementsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Follow a user
         * @param {string} otherUserUuid ID of the user to follow
         * @param {ApiUserFollowRequest} [apiUserFollowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserFollow(otherUserUuid: string, apiUserFollowRequest?: ApiUserFollowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRelationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserFollow(otherUserUuid, apiUserFollowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserFollow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get users who follow the specified user
         * @param {string} uuid ID of the user
         * @param {number} [limit] Limit the number of results
         * @param {string} [cursor] Cursor for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserFollowersList(uuid: string, limit?: number, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowersList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserFollowersList(uuid, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserFollowersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get users that the specified user follows
         * @param {string} uuid ID of the user
         * @param {number} [limit] Limit the number of results
         * @param {string} [cursor] Cursor for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserFollowingList(uuid: string, limit?: number, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowersList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserFollowingList(uuid, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserFollowingList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} otherUserUuid ID of the user to block
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRelationsBlock(otherUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRelationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRelationsBlock(otherUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserRelationsBlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} otherUserUuid ID of the user to unblock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRelationsUnblock(otherUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRelationship>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRelationsUnblock(otherUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserRelationsUnblock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get relationship details between two users
         * @param {string} otherUserUuid ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRelationshipDetails(otherUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRelationshipResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRelationshipDetails(otherUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserRelationshipDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unfollow a user
         * @param {string} otherUserUuid ID of the user to unfollow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserUnfollow(otherUserUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserUnfollow(otherUserUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.apiUserUnfollow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityExperiences(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperiencesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityExperiences(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communityExperiences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Community global configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityGlobalConfigs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityGlobalConfigs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityGlobalConfigs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communityGlobalConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a List of all the Media (Images) assigned to the posts and comments of the group.
         * @param {string} groupId 
         * @param {string} [orderBy] 
         * @param {string} [offset] 
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityGroupsMedia(groupId: string, orderBy?: string, offset?: string, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityGroupsMedia(groupId, orderBy, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communityGroupsMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * retrieve media
         * @param {string} [groupId] 
         * @param {string} [limit] 
         * @param {string} [cursor] 
         * @param {string} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityMediaList(groupId?: string, limit?: string, cursor?: string, tags?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityMediaList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityMediaList(groupId, limit, cursor, tags, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communityMediaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get relevant news for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communityNews(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsWidgetItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communityNews(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.communityNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all valid conversation participants
         * @param {string} chatId 
         * @param {string} [limit] 
         * @param {string} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationParticipantsList(chatId: string, limit?: string, offset?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationParticipantsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationParticipantsList(chatId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.conversationParticipantsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update specific conversation participant notification setting
         * @param {string} id 
         * @param {ConversationParticipantsNotificationUpdateRequest} [conversationParticipantsNotificationUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationParticipantsNotificationUpdate(id: string, conversationParticipantsNotificationUpdateRequest?: ConversationParticipantsNotificationUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationParticipantsNotificationUpdate(id, conversationParticipantsNotificationUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.conversationParticipantsNotificationUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * list conversations
         * @param {number | null} [limit] 
         * @param {number | null} [before] 
         * @param {number | null} [after] 
         * @param {number | null} [diff] 
         * @param {Array<ConversationsListTypesEnum>} [types] 
         * @param {boolean | null} [unreadOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async conversationsList(limit?: number | null, before?: number | null, after?: number | null, diff?: number | null, types?: Array<ConversationsListTypesEnum>, unreadOnly?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.conversationsList(limit, before, after, diff, types, unreadOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.conversationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} groupId External group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalGroupDetails(groupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalGroupDetailsResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalGroupDetails(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.externalGroupDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * retrieve base information for a single group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDetailsType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.groupDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get avaiable Group participants filters
         * @param {string} groupId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupParticipantsFilters(groupId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupParticipantFilter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupParticipantsFilters(groupId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.groupParticipantsFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * retrieve points of interest for a group
         * @param {string} id 
         * @param {string} [location] 
         * @param {string} [groupId] 
         * @param {string} [radius] 
         * @param {string} [mapBound] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupPointsOfInterest(id: string, location?: string, groupId?: string, radius?: string, mapBound?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupPointsOfInterest200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupPointsOfInterest(id, location, groupId, radius, mapBound, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.groupPointsOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * retrieve basic information required in the group rating page header
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupRatingsGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupRatingsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupRatingsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.groupRatingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve top participants for a single group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupTopParticipants(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupTopParticipants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupTopParticipants(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.groupTopParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get groups using a text query
         * @param {string} [query] 
         * @param {boolean} [userGroups] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupsByText(query?: string, userGroups?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupSearchItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupsByText(query, userGroups, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.searchGroupsByText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get avaiable Group participants filters
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1GroupParticipantsFilters(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GroupParticipantsFilters200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1GroupParticipantsFilters(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.v1GroupParticipantsFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete user session
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v2ApiLogout(c24session: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v2ApiLogout(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunityApi.v2ApiLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunityApi - factory interface
 * @export
 */
export const CommunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunityApiFp(configuration)
    return {
        /**
         * Get backoffice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackofficeInformation(options?: RawAxiosRequestConfig): AxiosPromise<ApiBackofficeInformation200Response> {
            return localVarFp.apiBackofficeInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * Get build information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBuildInformation(options?: RawAxiosRequestConfig): AxiosPromise<ApiBuildInformation200Response> {
            return localVarFp.apiBuildInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommunityApiApiCommunityNotificationsAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityNotificationsAuth(requestParameters: CommunityApiApiCommunityNotificationsAuthRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCommunityNotificationsAuth(requestParameters.apiCommunityNotificationsAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides a list of environments and their base urls.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEnvironmentsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiEnvironmentsList200ResponseInner>> {
            return localVarFp.apiEnvironmentsList(options).then((request) => request(axios, basePath));
        },
        /**
         * List all alternative groups for post creation
         * @param {CommunityApiApiGroupPostingAlternativesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupPostingAlternatives(requestParameters: CommunityApiApiGroupPostingAlternativesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiGroupPostingAlternatives200Response> {
            return localVarFp.apiGroupPostingAlternatives(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Responds with a list of suggested groups.
         * @param {CommunityApiApiGroupSuggestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGroupSuggest(requestParameters: CommunityApiApiGroupSuggestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiGroupSuggest200Response> {
            return localVarFp.apiGroupSuggest(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Responds with a list of suggested groups.
         * @param {CommunityApiApiHotelSuggestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHotelSuggest(requestParameters: CommunityApiApiHotelSuggestRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiHotelSuggest200Response> {
            return localVarFp.apiHotelSuggest(requestParameters.limit, requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate referrer url
         * @param {CommunityApiApiReferrerurlValidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReferrerurlValidate(requestParameters: CommunityApiApiReferrerurlValidateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiReferrerurlValidate200Response> {
            return localVarFp.apiReferrerurlValidate(requestParameters.apiReferrerurlValidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Response user highest earned or next
         * @param {CommunityApiApiUserAchievementsHighestEarnedOrNextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAchievementsHighestEarnedOrNext(requestParameters: CommunityApiApiUserAchievementsHighestEarnedOrNextRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserAchievementsHighestEarnedOrNext200Response> {
            return localVarFp.apiUserAchievementsHighestEarnedOrNext(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Response user achievements
         * @param {CommunityApiApiUserAchievementsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserAchievementsList(requestParameters: CommunityApiApiUserAchievementsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiUserAchievementsHighestEarnedOrNext200Response> {
            return localVarFp.apiUserAchievementsList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow a user
         * @param {CommunityApiApiUserFollowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollow(requestParameters: CommunityApiApiUserFollowRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRelationship> {
            return localVarFp.apiUserFollow(requestParameters.otherUserUuid, requestParameters.apiUserFollowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get users who follow the specified user
         * @param {CommunityApiApiUserFollowersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollowersList(requestParameters: CommunityApiApiUserFollowersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowersList> {
            return localVarFp.apiUserFollowersList(requestParameters.uuid, requestParameters.limit, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Get users that the specified user follows
         * @param {CommunityApiApiUserFollowingListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserFollowingList(requestParameters: CommunityApiApiUserFollowingListRequest, options?: RawAxiosRequestConfig): AxiosPromise<FollowersList> {
            return localVarFp.apiUserFollowingList(requestParameters.uuid, requestParameters.limit, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommunityApiApiUserRelationsBlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationsBlock(requestParameters: CommunityApiApiUserRelationsBlockRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRelationship> {
            return localVarFp.apiUserRelationsBlock(requestParameters.otherUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommunityApiApiUserRelationsUnblockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationsUnblock(requestParameters: CommunityApiApiUserRelationsUnblockRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRelationship> {
            return localVarFp.apiUserRelationsUnblock(requestParameters.otherUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get relationship details between two users
         * @param {CommunityApiApiUserRelationshipDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRelationshipDetails(requestParameters: CommunityApiApiUserRelationshipDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserRelationshipResult> {
            return localVarFp.apiUserRelationshipDetails(requestParameters.otherUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unfollow a user
         * @param {CommunityApiApiUserUnfollowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserUnfollow(requestParameters: CommunityApiApiUserUnfollowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiUserUnfollow(requestParameters.otherUserUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommunityApiCommunityExperiencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityExperiences(requestParameters: CommunityApiCommunityExperiencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExperiencesList> {
            return localVarFp.communityExperiences(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Community global configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityGlobalConfigs(options?: RawAxiosRequestConfig): AxiosPromise<CommunityGlobalConfigs200Response> {
            return localVarFp.communityGlobalConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a List of all the Media (Images) assigned to the posts and comments of the group.
         * @param {CommunityApiCommunityGroupsMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityGroupsMedia(requestParameters: CommunityApiCommunityGroupsMediaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communityGroupsMedia(requestParameters.groupId, requestParameters.orderBy, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieve media
         * @param {CommunityApiCommunityMediaListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityMediaList(requestParameters: CommunityApiCommunityMediaListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommunityMediaList200Response> {
            return localVarFp.communityMediaList(requestParameters.groupId, requestParameters.limit, requestParameters.cursor, requestParameters.tags, options).then((request) => request(axios, basePath));
        },
        /**
         * get relevant news for authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communityNews(options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsWidgetItem>> {
            return localVarFp.communityNews(options).then((request) => request(axios, basePath));
        },
        /**
         * List all valid conversation participants
         * @param {CommunityApiConversationParticipantsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationParticipantsList(requestParameters: CommunityApiConversationParticipantsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConversationParticipantsList200Response> {
            return localVarFp.conversationParticipantsList(requestParameters.chatId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update specific conversation participant notification setting
         * @param {CommunityApiConversationParticipantsNotificationUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationParticipantsNotificationUpdate(requestParameters: CommunityApiConversationParticipantsNotificationUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.conversationParticipantsNotificationUpdate(requestParameters.id, requestParameters.conversationParticipantsNotificationUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * list conversations
         * @param {CommunityApiConversationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationsList(requestParameters: CommunityApiConversationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ConversationList> {
            return localVarFp.conversationsList(requestParameters.limit, requestParameters.before, requestParameters.after, requestParameters.diff, requestParameters.types, requestParameters.unreadOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommunityApiExternalGroupDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalGroupDetails(requestParameters: CommunityApiExternalGroupDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalGroupDetailsResult> {
            return localVarFp.externalGroupDetails(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieve base information for a single group
         * @param {CommunityApiGroupDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDetails(requestParameters: CommunityApiGroupDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupDetailsType> {
            return localVarFp.groupDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get avaiable Group participants filters
         * @param {CommunityApiGroupParticipantsFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupParticipantsFilters(requestParameters: CommunityApiGroupParticipantsFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupParticipantFilter>> {
            return localVarFp.groupParticipantsFilters(requestParameters.groupId, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieve points of interest for a group
         * @param {CommunityApiGroupPointsOfInterestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPointsOfInterest(requestParameters: CommunityApiGroupPointsOfInterestRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupPointsOfInterest200ResponseInner>> {
            return localVarFp.groupPointsOfInterest(requestParameters.id, requestParameters.location, requestParameters.groupId, requestParameters.radius, requestParameters.mapBound, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieve basic information required in the group rating page header
         * @param {CommunityApiGroupRatingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRatingsGet(requestParameters: CommunityApiGroupRatingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupRatingsGet200Response> {
            return localVarFp.groupRatingsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve top participants for a single group
         * @param {CommunityApiGroupTopParticipantsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupTopParticipants(requestParameters: CommunityApiGroupTopParticipantsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupTopParticipants200Response> {
            return localVarFp.groupTopParticipants(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get groups using a text query
         * @param {CommunityApiSearchGroupsByTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsByText(requestParameters: CommunityApiSearchGroupsByTextRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupSearchItem>> {
            return localVarFp.searchGroupsByText(requestParameters.query, requestParameters.userGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * Get avaiable Group participants filters
         * @param {CommunityApiV1GroupParticipantsFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GroupParticipantsFilters(requestParameters: CommunityApiV1GroupParticipantsFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<V1GroupParticipantsFilters200Response> {
            return localVarFp.v1GroupParticipantsFilters(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete user session
         * @param {CommunityApiV2ApiLogoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ApiLogout(requestParameters: CommunityApiV2ApiLogoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v2ApiLogout(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCommunityNotificationsAuth operation in CommunityApi.
 * @export
 * @interface CommunityApiApiCommunityNotificationsAuthRequest
 */
export interface CommunityApiApiCommunityNotificationsAuthRequest {
    /**
     * 
     * @type {ApiCommunityNotificationsAuthRequest}
     * @memberof CommunityApiApiCommunityNotificationsAuth
     */
    readonly apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest
}

/**
 * Request parameters for apiGroupPostingAlternatives operation in CommunityApi.
 * @export
 * @interface CommunityApiApiGroupPostingAlternativesRequest
 */
export interface CommunityApiApiGroupPostingAlternativesRequest {
    /**
     * id
     * @type {string}
     * @memberof CommunityApiApiGroupPostingAlternatives
     */
    readonly id: string
}

/**
 * Request parameters for apiGroupSuggest operation in CommunityApi.
 * @export
 * @interface CommunityApiApiGroupSuggestRequest
 */
export interface CommunityApiApiGroupSuggestRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiApiGroupSuggest
     */
    readonly limit?: string
}

/**
 * Request parameters for apiHotelSuggest operation in CommunityApi.
 * @export
 * @interface CommunityApiApiHotelSuggestRequest
 */
export interface CommunityApiApiHotelSuggestRequest {
    /**
     * 
     * @type {number}
     * @memberof CommunityApiApiHotelSuggest
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof CommunityApiApiHotelSuggest
     */
    readonly groupId?: number
}

/**
 * Request parameters for apiReferrerurlValidate operation in CommunityApi.
 * @export
 * @interface CommunityApiApiReferrerurlValidateRequest
 */
export interface CommunityApiApiReferrerurlValidateRequest {
    /**
     * 
     * @type {ApiReferrerurlValidateRequest}
     * @memberof CommunityApiApiReferrerurlValidate
     */
    readonly apiReferrerurlValidateRequest?: ApiReferrerurlValidateRequest
}

/**
 * Request parameters for apiUserAchievementsHighestEarnedOrNext operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserAchievementsHighestEarnedOrNextRequest
 */
export interface CommunityApiApiUserAchievementsHighestEarnedOrNextRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiApiUserAchievementsHighestEarnedOrNext
     */
    readonly id: string
}

/**
 * Request parameters for apiUserAchievementsList operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserAchievementsListRequest
 */
export interface CommunityApiApiUserAchievementsListRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiApiUserAchievementsList
     */
    readonly id: string
}

/**
 * Request parameters for apiUserFollow operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserFollowRequest
 */
export interface CommunityApiApiUserFollowRequest {
    /**
     * ID of the user to follow
     * @type {string}
     * @memberof CommunityApiApiUserFollow
     */
    readonly otherUserUuid: string

    /**
     * 
     * @type {ApiUserFollowRequest}
     * @memberof CommunityApiApiUserFollow
     */
    readonly apiUserFollowRequest?: ApiUserFollowRequest
}

/**
 * Request parameters for apiUserFollowersList operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserFollowersListRequest
 */
export interface CommunityApiApiUserFollowersListRequest {
    /**
     * ID of the user
     * @type {string}
     * @memberof CommunityApiApiUserFollowersList
     */
    readonly uuid: string

    /**
     * Limit the number of results
     * @type {number}
     * @memberof CommunityApiApiUserFollowersList
     */
    readonly limit?: number

    /**
     * Cursor for pagination
     * @type {string}
     * @memberof CommunityApiApiUserFollowersList
     */
    readonly cursor?: string
}

/**
 * Request parameters for apiUserFollowingList operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserFollowingListRequest
 */
export interface CommunityApiApiUserFollowingListRequest {
    /**
     * ID of the user
     * @type {string}
     * @memberof CommunityApiApiUserFollowingList
     */
    readonly uuid: string

    /**
     * Limit the number of results
     * @type {number}
     * @memberof CommunityApiApiUserFollowingList
     */
    readonly limit?: number

    /**
     * Cursor for pagination
     * @type {string}
     * @memberof CommunityApiApiUserFollowingList
     */
    readonly cursor?: string
}

/**
 * Request parameters for apiUserRelationsBlock operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserRelationsBlockRequest
 */
export interface CommunityApiApiUserRelationsBlockRequest {
    /**
     * ID of the user to block
     * @type {string}
     * @memberof CommunityApiApiUserRelationsBlock
     */
    readonly otherUserUuid: string
}

/**
 * Request parameters for apiUserRelationsUnblock operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserRelationsUnblockRequest
 */
export interface CommunityApiApiUserRelationsUnblockRequest {
    /**
     * ID of the user to unblock
     * @type {string}
     * @memberof CommunityApiApiUserRelationsUnblock
     */
    readonly otherUserUuid: string
}

/**
 * Request parameters for apiUserRelationshipDetails operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserRelationshipDetailsRequest
 */
export interface CommunityApiApiUserRelationshipDetailsRequest {
    /**
     * ID of the user
     * @type {string}
     * @memberof CommunityApiApiUserRelationshipDetails
     */
    readonly otherUserUuid: string
}

/**
 * Request parameters for apiUserUnfollow operation in CommunityApi.
 * @export
 * @interface CommunityApiApiUserUnfollowRequest
 */
export interface CommunityApiApiUserUnfollowRequest {
    /**
     * ID of the user to unfollow
     * @type {string}
     * @memberof CommunityApiApiUserUnfollow
     */
    readonly otherUserUuid: string
}

/**
 * Request parameters for communityExperiences operation in CommunityApi.
 * @export
 * @interface CommunityApiCommunityExperiencesRequest
 */
export interface CommunityApiCommunityExperiencesRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityExperiences
     */
    readonly groupId: string
}

/**
 * Request parameters for communityGroupsMedia operation in CommunityApi.
 * @export
 * @interface CommunityApiCommunityGroupsMediaRequest
 */
export interface CommunityApiCommunityGroupsMediaRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityGroupsMedia
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityGroupsMedia
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityGroupsMedia
     */
    readonly offset?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityGroupsMedia
     */
    readonly limit?: string
}

/**
 * Request parameters for communityMediaList operation in CommunityApi.
 * @export
 * @interface CommunityApiCommunityMediaListRequest
 */
export interface CommunityApiCommunityMediaListRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityMediaList
     */
    readonly groupId?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityMediaList
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityMediaList
     */
    readonly cursor?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiCommunityMediaList
     */
    readonly tags?: string
}

/**
 * Request parameters for conversationParticipantsList operation in CommunityApi.
 * @export
 * @interface CommunityApiConversationParticipantsListRequest
 */
export interface CommunityApiConversationParticipantsListRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiConversationParticipantsList
     */
    readonly chatId: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiConversationParticipantsList
     */
    readonly limit?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiConversationParticipantsList
     */
    readonly offset?: string
}

/**
 * Request parameters for conversationParticipantsNotificationUpdate operation in CommunityApi.
 * @export
 * @interface CommunityApiConversationParticipantsNotificationUpdateRequest
 */
export interface CommunityApiConversationParticipantsNotificationUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiConversationParticipantsNotificationUpdate
     */
    readonly id: string

    /**
     * 
     * @type {ConversationParticipantsNotificationUpdateRequest}
     * @memberof CommunityApiConversationParticipantsNotificationUpdate
     */
    readonly conversationParticipantsNotificationUpdateRequest?: ConversationParticipantsNotificationUpdateRequest
}

/**
 * Request parameters for conversationsList operation in CommunityApi.
 * @export
 * @interface CommunityApiConversationsListRequest
 */
export interface CommunityApiConversationsListRequest {
    /**
     * 
     * @type {number}
     * @memberof CommunityApiConversationsList
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CommunityApiConversationsList
     */
    readonly before?: number | null

    /**
     * 
     * @type {number}
     * @memberof CommunityApiConversationsList
     */
    readonly after?: number | null

    /**
     * 
     * @type {number}
     * @memberof CommunityApiConversationsList
     */
    readonly diff?: number | null

    /**
     * 
     * @type {Array}
     * @memberof CommunityApiConversationsList
     */
    readonly types?: Array<ConversationsListTypesEnum>

    /**
     * 
     * @type {boolean}
     * @memberof CommunityApiConversationsList
     */
    readonly unreadOnly?: boolean | null
}

/**
 * Request parameters for externalGroupDetails operation in CommunityApi.
 * @export
 * @interface CommunityApiExternalGroupDetailsRequest
 */
export interface CommunityApiExternalGroupDetailsRequest {
    /**
     * External group ID
     * @type {number}
     * @memberof CommunityApiExternalGroupDetails
     */
    readonly groupId: number
}

/**
 * Request parameters for groupDetails operation in CommunityApi.
 * @export
 * @interface CommunityApiGroupDetailsRequest
 */
export interface CommunityApiGroupDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupDetails
     */
    readonly id: string
}

/**
 * Request parameters for groupParticipantsFilters operation in CommunityApi.
 * @export
 * @interface CommunityApiGroupParticipantsFiltersRequest
 */
export interface CommunityApiGroupParticipantsFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupParticipantsFilters
     */
    readonly groupId: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupParticipantsFilters
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupParticipantsFilters
     */
    readonly to?: string
}

/**
 * Request parameters for groupPointsOfInterest operation in CommunityApi.
 * @export
 * @interface CommunityApiGroupPointsOfInterestRequest
 */
export interface CommunityApiGroupPointsOfInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupPointsOfInterest
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupPointsOfInterest
     */
    readonly location?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupPointsOfInterest
     */
    readonly groupId?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupPointsOfInterest
     */
    readonly radius?: string

    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupPointsOfInterest
     */
    readonly mapBound?: string
}

/**
 * Request parameters for groupRatingsGet operation in CommunityApi.
 * @export
 * @interface CommunityApiGroupRatingsGetRequest
 */
export interface CommunityApiGroupRatingsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupRatingsGet
     */
    readonly id: string
}

/**
 * Request parameters for groupTopParticipants operation in CommunityApi.
 * @export
 * @interface CommunityApiGroupTopParticipantsRequest
 */
export interface CommunityApiGroupTopParticipantsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiGroupTopParticipants
     */
    readonly groupId: string
}

/**
 * Request parameters for searchGroupsByText operation in CommunityApi.
 * @export
 * @interface CommunityApiSearchGroupsByTextRequest
 */
export interface CommunityApiSearchGroupsByTextRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiSearchGroupsByText
     */
    readonly query?: string

    /**
     * 
     * @type {boolean}
     * @memberof CommunityApiSearchGroupsByText
     */
    readonly userGroups?: boolean
}

/**
 * Request parameters for v1GroupParticipantsFilters operation in CommunityApi.
 * @export
 * @interface CommunityApiV1GroupParticipantsFiltersRequest
 */
export interface CommunityApiV1GroupParticipantsFiltersRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiV1GroupParticipantsFilters
     */
    readonly groupId: string
}

/**
 * Request parameters for v2ApiLogout operation in CommunityApi.
 * @export
 * @interface CommunityApiV2ApiLogoutRequest
 */
export interface CommunityApiV2ApiLogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunityApiV2ApiLogout
     */
    readonly c24session: string
}

/**
 * CommunityApi - object-oriented interface
 * @export
 * @class CommunityApi
 * @extends {BaseAPI}
 */
export class CommunityApi extends BaseAPI {
    /**
     * Get backoffice information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiBackofficeInformation(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiBackofficeInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get build information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiBuildInformation(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiBuildInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommunityApiApiCommunityNotificationsAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiCommunityNotificationsAuth(requestParameters: CommunityApiApiCommunityNotificationsAuthRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiCommunityNotificationsAuth(requestParameters.apiCommunityNotificationsAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provides a list of environments and their base urls.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiEnvironmentsList(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiEnvironmentsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all alternative groups for post creation
     * @param {CommunityApiApiGroupPostingAlternativesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiGroupPostingAlternatives(requestParameters: CommunityApiApiGroupPostingAlternativesRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiGroupPostingAlternatives(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Responds with a list of suggested groups.
     * @param {CommunityApiApiGroupSuggestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiGroupSuggest(requestParameters: CommunityApiApiGroupSuggestRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiGroupSuggest(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Responds with a list of suggested groups.
     * @param {CommunityApiApiHotelSuggestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiHotelSuggest(requestParameters: CommunityApiApiHotelSuggestRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiHotelSuggest(requestParameters.limit, requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate referrer url
     * @param {CommunityApiApiReferrerurlValidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiReferrerurlValidate(requestParameters: CommunityApiApiReferrerurlValidateRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiReferrerurlValidate(requestParameters.apiReferrerurlValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Response user highest earned or next
     * @param {CommunityApiApiUserAchievementsHighestEarnedOrNextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserAchievementsHighestEarnedOrNext(requestParameters: CommunityApiApiUserAchievementsHighestEarnedOrNextRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserAchievementsHighestEarnedOrNext(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Response user achievements
     * @param {CommunityApiApiUserAchievementsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserAchievementsList(requestParameters: CommunityApiApiUserAchievementsListRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserAchievementsList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow a user
     * @param {CommunityApiApiUserFollowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserFollow(requestParameters: CommunityApiApiUserFollowRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserFollow(requestParameters.otherUserUuid, requestParameters.apiUserFollowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get users who follow the specified user
     * @param {CommunityApiApiUserFollowersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserFollowersList(requestParameters: CommunityApiApiUserFollowersListRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserFollowersList(requestParameters.uuid, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get users that the specified user follows
     * @param {CommunityApiApiUserFollowingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserFollowingList(requestParameters: CommunityApiApiUserFollowingListRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserFollowingList(requestParameters.uuid, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommunityApiApiUserRelationsBlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserRelationsBlock(requestParameters: CommunityApiApiUserRelationsBlockRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserRelationsBlock(requestParameters.otherUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommunityApiApiUserRelationsUnblockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserRelationsUnblock(requestParameters: CommunityApiApiUserRelationsUnblockRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserRelationsUnblock(requestParameters.otherUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get relationship details between two users
     * @param {CommunityApiApiUserRelationshipDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserRelationshipDetails(requestParameters: CommunityApiApiUserRelationshipDetailsRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserRelationshipDetails(requestParameters.otherUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unfollow a user
     * @param {CommunityApiApiUserUnfollowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public apiUserUnfollow(requestParameters: CommunityApiApiUserUnfollowRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).apiUserUnfollow(requestParameters.otherUserUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommunityApiCommunityExperiencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communityExperiences(requestParameters: CommunityApiCommunityExperiencesRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communityExperiences(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Community global configs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communityGlobalConfigs(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communityGlobalConfigs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a List of all the Media (Images) assigned to the posts and comments of the group.
     * @param {CommunityApiCommunityGroupsMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communityGroupsMedia(requestParameters: CommunityApiCommunityGroupsMediaRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communityGroupsMedia(requestParameters.groupId, requestParameters.orderBy, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieve media
     * @param {CommunityApiCommunityMediaListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communityMediaList(requestParameters: CommunityApiCommunityMediaListRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communityMediaList(requestParameters.groupId, requestParameters.limit, requestParameters.cursor, requestParameters.tags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get relevant news for authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public communityNews(options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).communityNews(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all valid conversation participants
     * @param {CommunityApiConversationParticipantsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public conversationParticipantsList(requestParameters: CommunityApiConversationParticipantsListRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).conversationParticipantsList(requestParameters.chatId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update specific conversation participant notification setting
     * @param {CommunityApiConversationParticipantsNotificationUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public conversationParticipantsNotificationUpdate(requestParameters: CommunityApiConversationParticipantsNotificationUpdateRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).conversationParticipantsNotificationUpdate(requestParameters.id, requestParameters.conversationParticipantsNotificationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * list conversations
     * @param {CommunityApiConversationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public conversationsList(requestParameters: CommunityApiConversationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).conversationsList(requestParameters.limit, requestParameters.before, requestParameters.after, requestParameters.diff, requestParameters.types, requestParameters.unreadOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommunityApiExternalGroupDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public externalGroupDetails(requestParameters: CommunityApiExternalGroupDetailsRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).externalGroupDetails(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieve base information for a single group
     * @param {CommunityApiGroupDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public groupDetails(requestParameters: CommunityApiGroupDetailsRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).groupDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get avaiable Group participants filters
     * @param {CommunityApiGroupParticipantsFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public groupParticipantsFilters(requestParameters: CommunityApiGroupParticipantsFiltersRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).groupParticipantsFilters(requestParameters.groupId, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieve points of interest for a group
     * @param {CommunityApiGroupPointsOfInterestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public groupPointsOfInterest(requestParameters: CommunityApiGroupPointsOfInterestRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).groupPointsOfInterest(requestParameters.id, requestParameters.location, requestParameters.groupId, requestParameters.radius, requestParameters.mapBound, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieve basic information required in the group rating page header
     * @param {CommunityApiGroupRatingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public groupRatingsGet(requestParameters: CommunityApiGroupRatingsGetRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).groupRatingsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve top participants for a single group
     * @param {CommunityApiGroupTopParticipantsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public groupTopParticipants(requestParameters: CommunityApiGroupTopParticipantsRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).groupTopParticipants(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get groups using a text query
     * @param {CommunityApiSearchGroupsByTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public searchGroupsByText(requestParameters: CommunityApiSearchGroupsByTextRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).searchGroupsByText(requestParameters.query, requestParameters.userGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get avaiable Group participants filters
     * @param {CommunityApiV1GroupParticipantsFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public v1GroupParticipantsFilters(requestParameters: CommunityApiV1GroupParticipantsFiltersRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).v1GroupParticipantsFilters(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete user session
     * @param {CommunityApiV2ApiLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunityApi
     */
    public v2ApiLogout(requestParameters: CommunityApiV2ApiLogoutRequest, options?: RawAxiosRequestConfig) {
        return CommunityApiFp(this.configuration).v2ApiLogout(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ConversationsListTypesEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;
export type ConversationsListTypesEnum = typeof ConversationsListTypesEnum[keyof typeof ConversationsListTypesEnum];


/**
 * TippspielApi - axios parameter creator
 * @export
 */
export const TippspielApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApiCommunityNotificationsAuthRequest} [apiCommunityNotificationsAuthRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityNotificationsAuth: async (apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/community/notifications/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiCommunityNotificationsAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TippspielApi - functional programming interface
 * @export
 */
export const TippspielApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TippspielApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApiCommunityNotificationsAuthRequest} [apiCommunityNotificationsAuthRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCommunityNotificationsAuth(apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCommunityNotificationsAuth(apiCommunityNotificationsAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TippspielApi.apiCommunityNotificationsAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TippspielApi - factory interface
 * @export
 */
export const TippspielApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TippspielApiFp(configuration)
    return {
        /**
         * 
         * @param {TippspielApiApiCommunityNotificationsAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCommunityNotificationsAuth(requestParameters: TippspielApiApiCommunityNotificationsAuthRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiCommunityNotificationsAuth(requestParameters.apiCommunityNotificationsAuthRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiCommunityNotificationsAuth operation in TippspielApi.
 * @export
 * @interface TippspielApiApiCommunityNotificationsAuthRequest
 */
export interface TippspielApiApiCommunityNotificationsAuthRequest {
    /**
     * 
     * @type {ApiCommunityNotificationsAuthRequest}
     * @memberof TippspielApiApiCommunityNotificationsAuth
     */
    readonly apiCommunityNotificationsAuthRequest?: ApiCommunityNotificationsAuthRequest
}

/**
 * TippspielApi - object-oriented interface
 * @export
 * @class TippspielApi
 * @extends {BaseAPI}
 */
export class TippspielApi extends BaseAPI {
    /**
     * 
     * @param {TippspielApiApiCommunityNotificationsAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TippspielApi
     */
    public apiCommunityNotificationsAuth(requestParameters: TippspielApiApiCommunityNotificationsAuthRequest = {}, options?: RawAxiosRequestConfig) {
        return TippspielApiFp(this.configuration).apiCommunityNotificationsAuth(requestParameters.apiCommunityNotificationsAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



